var map = {
	"./calculated-splits/settings/module.settings.panel.js": [
		784,
		8
	],
	"./checkins/settings/module.settings.panel.js": [
		778,
		10
	],
	"./time-trial/settings/module.settings.panel.js": [
		779,
		13
	],
	"./wag-profile-test/settings/module.settings.panel.js": [
		780,
		16
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 709;
module.exports = webpackAsyncContext;